var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.625 6.99992C0.625 6.99992 3.125 2.33325 7.5 2.33325C11.875 2.33325 14.375 6.99992 14.375 6.99992C14.375 6.99992 11.875 11.6666 7.5 11.6666C3.125 11.6666 0.625 6.99992 0.625 6.99992Z",
    stroke: "#F97D09",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 8.74992C8.53553 8.74992 9.375 7.96642 9.375 6.99992C9.375 6.03342 8.53553 5.24992 7.5 5.24992C6.46447 5.24992 5.625 6.03342 5.625 6.99992C5.625 7.96642 6.46447 8.74992 7.5 8.74992Z",
    stroke: "#F97D09",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewIcon);
export default __webpack_public_path__ + "static/media/ViewIcon.6844fd115e419d0c11c5f42d81c1239e.svg";
export { ForwardRef as ReactComponent };